import { usePayPalCardFields } from "@paypal/react-paypal-js";
import { useState } from "react";
import Common from "../../Common/Common";

const SubmitPayment = () => {
    const [isPaying, setIsPaying] = useState(false);
    const { cardFieldsForm, fields } = usePayPalCardFields();

    const handleClick = async () => {
        if (!cardFieldsForm) {
            const childErrorMessage = "Unable to find any child components in the <PayPalCardFieldsProvider />";
            throw new Error(childErrorMessage);
        }
        const formState = await cardFieldsForm.getState();
        if (!formState.isFormValid) {
            Common.Common.PopTips = "The payment form is invalid";
            return;
        }
        setIsPaying(true);
        cardFieldsForm.submit().then(()=>{
            setIsPaying(false);
        }).catch((err) => {
            console.log("==============>>>>cardFieldsForm err: ", err);
            setIsPaying(false);
            Common.Common.PopTips = "Bank card information error";
        });
    };

    return (
        <button
            className={isPaying ? "btn" : "btn btn-primary"}
            style={
                isPaying?{ width:"100%", height:"40px", background:"gray", fontSize:"20px", color:"white" }
                :{ width:"100%", height:"40px", background:"#00166e", fontSize:"20px", color:"white",cursor:"pointer" }
            }
            onClick={handleClick}
        >
            Pay (Bank Card or Visa)
        </button>
    );
};

export default SubmitPayment;